export default "__VITE_ASSET__2e68327a__"